// @ts-nocheck
import type { ApolloClient } from '@apollo/client/core';
import { defaultDataIdFromObject, HttpLink } from '@apollo/client/core';
import { buildAxiosFetch } from '@lifeomic/axios-fetch';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloLink, concat } from 'apollo-link';
import type { Context } from '@nuxt/types';
import typeDefs from '@/apollo/typeDefs.gql';
import introspectionQueryResultData from '@/apollo/fragments.json';

// FIXME: please add real type
type Cache = {
  fragmentMatcher: unknown;
  dataIdFromObject: (obj: unknown) => unknown;
};

export default (context: Context): ApolloClient<Cache> => {
  const { app } = context;

  const middlewareLink = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    return forward(operation);
  });

  const httpLink = new HttpLink({
    uri: '/graphql',
    credentials: 'include',
    fetch: (uri, options) => {
      const fetch = buildAxiosFetch(app.$api);

      return fetch(uri, options);
    },
  });

  return {
    defaultHttpLink: false,
    link: concat(middlewareLink, httpLink),
    cache: new InMemoryCache({
      fragmentMatcher: new IntrospectionFragmentMatcher({ introspectionQueryResultData }),
      dataIdFromObject(responseObject) {
        if (responseObject.__typename === 'DealQuarter') {
          return `DealQuarter:${responseObject.year}-${responseObject.quarter}`;
        } else {
          return defaultDataIdFromObject(responseObject);
        }
      },
    }),
    typeDefs,
    resolvers: {
      Company: {
        lowerName(company) {
          return company.name?.toLowerCase().trim() ?? '';
        },
      },
    },
    typePolicies: {
      Country: {
        keyFields: ['name'],
      },
    },
  };
};
